export default {
  singleLabel: "Libellé de frais",
  storeNamespace: 'fee_label',
  authFeature: 'location-for-account',
  listRouteName: "FeeLabelList",
  newRouteName: "FeeLabelNew",
  editRouteName: "FeeLabelEdit",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'FeeLabelForm',
  hideActionPdfButton: true,
  csvExportFilenamePrefix: 'libelles-de-frais',
  titleField: 'label',
  sortBy: 'label',
  fields: [
    {
      name: 'label',
      label: "Libellé",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
    },
    {
      name: 'category',
      label: "Catégorie par défaut",
      type: 'select',
      inForm: true,
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$store.getters['fee_label/getCategoryLabel'](value) : null,
      options: ($store) => $store.getters['fee_label/getCategoriesForSelect'],
    },
    {
      name: 'default_unit_price',
      label: "Montant unitaire HT par défaut (€)",
      type: 'number',
      step: '0.01',
      inForm: true,
      inList: true,
      sortable: true,
      inDetail: true,
      inCsvExport: true,
      // Optionnel : beaucoup de frais varient à chaque fois (carburant, remise en état).
    },
    {
      name: 'active',
      label: "Actif",
      type: 'yesno',
      inForm: true,
      inList: true,
      inDetail: true,
      inCsvExport: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/FeeLabel/config.js